import { css, html, LitElement } from 'lit'
import { customElement } from 'lit/decorators.js'

import { BlockSettingsElementModel, GridElementModel } from '../api/ContentDeliveryApi.schemas'
import { renderGridElement } from '../RenderElement'
import { UmbracoPage } from '../ContentLoader'

@customElement('lindberg-grid')
export class Grid extends LitElement {
	static styles = css`
        :host {
            display: grid;
            grid-template-columns: repeat(var(--columns), 1fr);
            /* grid-auto-rows: 1fr; */
            gap: var(--grid-gutter);
            @media (width < 600px) { 
                grid-template-columns: 1fr;
                :host > *{
                    grid-column: initial;
                    grid-row: initial;
                }
            }
        }

        :host > * {
            grid-column: span var(--column-span); 
            grid-row: span var(--row-span);
            aspect-ratio: var(--aspect-ratio);
        }

        :host(.collection){
            @media (width >= 600px) {
                gap: 0;
                --vertical-align: center;
                
                grid-template-columns: repeat(2, 1fr);
    	        grid-auto-flow: row dense;

                & > * {
                    grid-column: span 1;
                    grid-row: span 1;
                }

                & > :nth-child(4n - 1) {
                    grid-column: 2;
                    text-align: right;
                }

                & > :nth-child(4n) {
                    grid-column: 1;
                    text-align: left;
                }
            }
        }
    `
	data!: { content: GridElementModel; settings: BlockSettingsElementModel }
    root!: UmbracoPage;

	render() {
        if(this.data.settings?.properties.layout) this.classList.add(this.data.settings.properties.layout as string)
        if(this.data.settings?.properties?.backgroundColor?.value) this.style.setProperty('background', this.data.settings.properties.backgroundColor.value)
		return html`${this.data.content.properties?.items?.items.map(x => renderGridElement(x, this.root))}`
	}
}
